import { API as OmniAPI } from "omni-neo-api";
import React from "react";

export const OmniAPIContext = React.createContext<OmniAPI>(new OmniAPI({}));

export default OmniAPIContext;
